import { render, staticRenderFns } from "./posters.vue?vue&type=template&id=de85d318&scoped=true&"
import script from "./posters.vue?vue&type=script&lang=js&"
export * from "./posters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de85d318",
  null
  
)

export default component.exports